import {IOrganization} from './organization.model';

export interface IStep {
  id?: number;
  itemName?: string;
  score?: any;
  needValidation?: any;
  countValidation?: any;
  color?: any;
  status?: string;
  customer_status?: string;
  description?: string;
  dashboard_section?: string;
  part?: string;
  organization?: IOrganization;
  createdDate?: any;
  lastModifiedDate?: any;
  last_modified_date?: any;
  created_date?: any;

}

export class Step implements IStep {
  constructor(public id?: number, public itemName?: string, public score?: any,  public color?: any, public status?: string, public customer_status?: string, public description?: string
    , public organization?: IOrganization,
              public lastModifiedDate?: any,
              public createdDate?: any,) {
  }
}
